import { DateTime } from "luxon";
import { useState } from "react";
import { toast } from "react-toastify";
import dataService from "../../../../../../helpers/dataService";
import tools from "../../../../../../helpers/tools";
import Compteur from "../../../../../common/CarteLead/Compteur";
import DocumentsCompacts from "../../../../../common/CarteLead/DocumentsCompacts";
import TitreZone from "../../../../../common/CarteLead/TitreZone";
import DropZone from "../../../../ClientListPage/ClientList/ClientItem/CompanyList/CompanyItem/BottomPanel/BPDocuments/BPDocumentItem/DropZone";

const FORMATS_ACCEPTES = ["image/jpeg", "image/png", "application/pdf"];

// Devis d'un lead entreprise ou DOMI : les devis déjà déposés (fichiers de
// l'API, `lead.medias`, du type de devis du produit) et le dépôt d'un nouveau
// devis par un bouton ou en glissant un fichier sur la zone (POST /files).
const ZoneDevis = ({ lead, produit, typeDevis, entityRef, canUpload, onDepose }) => {
  const [isUploading, setIsUploading] = useState(false);
  const nomClient = (lead.client && lead.client.company) || tools.getFullName(lead.user) || "";

  const telecharger = (media, preview) =>
    new Promise((resolve) => {
      const morceaux = String(media.fileName || "").split(".");
      dataService.downloadFile(
        `files/${media.id}`,
        {
          preview,
          filename: tools.getDocumentName({
            fileExt: morceaux[morceaux.length - 1],
            documentName: (media.fileType && media.fileType.name) || "",
            productName: lead.productId || "",
            companyName: nomClient,
            uploadedAt: media.uploadedAt ? DateTime.fromISO(media.uploadedAt).toFormat("yyyy") : "",
          }),
        },
        () => {},
        () => toast.error("Le téléchargement du document a échoué. Veuillez réessayer."),
        resolve
      );
    });

  const documents = (Array.isArray(lead.medias) ? lead.medias : [])
    .filter((m) => typeDevis && m.fileType && m.fileType.code === typeDevis.code)
    .map((m) => ({
      id: m.id,
      // Le nom de fichier de l'API est un identifiant : le libellé du type est plus parlant.
      nom: (m.fileType && m.fileType.name) || m.fileName || "document",
      fichier: m.fileName,
      deposeLe: m.uploadedAt,
      ouvrir: () => telecharger(m, true),
      telecharger: () => telecharger(m, false),
    }));

  const onDropFiles = (files) => {
    if (!typeDevis) {
      toast.error("Le type de devis de ce produit est inconnu : dépôt impossible.");
      return;
    }
    if (!files.length || !FORMATS_ACCEPTES.includes(files[0].type)) {
      toast.error("Le fichier choisi est incorrect. Les formats acceptés sont jpeg, png et pdf.");
      return;
    }
    const data = new FormData();
    data.append("file", files[0]);
    data.append("fileType", typeDevis.id);
    data.append("entityRef", entityRef);
    data.append("entityId", lead.id);
    setIsUploading(true);
    dataService.postFile(
      "files",
      data,
      (media) => {
        toast.success("Document déposé.");
        // L'API peut renvoyer le type par son seul identifiant : on garde le nôtre.
        onDepose({ ...media, fileType: media.fileType && typeof media.fileType === "object" ? media.fileType : typeDevis });
      },
      () => toast.error("L'envoi du document a échoué. Veuillez réessayer."),
      () => setIsUploading(false)
    );
  };

  return (
    <section className="la-zone la-zone--devis" aria-label={`Devis ${produit.code}`}>
      <TitreZone icone="fa-file-invoice">
        Devis {produit.code} <Compteur plein={documents.length > 0}>{documents.length}</Compteur>
      </TitreZone>
      <DocumentsCompacts documents={documents} emptyLabel="Aucun devis déposé." />
      {canUpload && <DropZone onDropFiles={onDropFiles} isUploading={isUploading} compact label="Déposer un devis" />}
    </section>
  );
};

export default ZoneDevis;
